import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@/store/store-hooks'
import { MedChronAssetActions } from '../store/slice'

/** Consume the cross-route notice once, then keep it only for this landing-page visit. */
export function useAddFilesLeaseExpiredNotice(matterId?: string) {
  const { key } = useLocation()
  const dispatch = useAppDispatch()
  const expiredMatterId = useAppSelector((state) => state.medChronAssetState.addFilesLeaseExpiredMatterId)
  const [notice, setNotice] = useState({ key, matterId, visible: Boolean(matterId && expiredMatterId === matterId) })

  if (notice.key !== key || notice.matterId !== matterId) {
    setNotice({ key, matterId, visible: false })
  }

  useEffect(() => {
    if (expiredMatterId) dispatch(MedChronAssetActions.setAddFilesLeaseExpiredMatterId(null))
  }, [expiredMatterId, dispatch])

  return notice.visible
}
